var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLetter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.667 3.167A.837.837 0 0 0 1.834 4v8c0 .457.376.833.833.833h10.666a.837.837 0 0 0 .834-.833V4a.837.837 0 0 0-.833-.833zM.833 4c0-1.01.824-1.833 1.834-1.833h10.666c1.01 0 1.834.823 1.834 1.833v8c0 1.01-.824 1.833-1.833 1.833H2.667A1.837 1.837 0 0 1 .833 12z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M.924 3.713a.5.5 0 0 1 .696-.123L8 8.056l6.38-4.466a.5.5 0 0 1 .574.82L8.287 9.076a.5.5 0 0 1-.574 0L1.047 4.41a.5.5 0 0 1-.123-.697"
})));
export default SvgLetter;